import { SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

export const CONFIG_WIDGETS_NAMES = {
  OVER_TIME_CHART: 'over_time_chart',
  DONUT_CHART: 'donut_chart'
};

const SETTING_NAME = SettingValues.RESOURCE_ALLOCATION_WIDGETS_CONFIG;

const useRaWidgetsConfig = () => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const value = getSettingOrDefinitionValue({
    name: SETTING_NAME
  });

  const onSave = async settingPayload =>
    await updateSetting(SETTING_NAME, settingPayload);

  return { value, onSave };
};

export default useRaWidgetsConfig;
